import CloseIcon from 'assets/icons/close.svg';
import WhiteCloseIcon from 'assets/icons/close-white.svg';
import { modalModes, modalTabs } from 'utils/constants';
import { HeaderProps } from 'interfaces/components/dataEntryModal/Header';
import Button from 'components/Button';
import { useAuth } from 'context/AuthContext';

const Header = ({
  mode,
  onClose,
  selectedTabs,
  setSelectedTabs
}: HeaderProps) => {
  const { isAuthenticated } = useAuth();

  const handleTabClick = (tab: modalTabs) => {
    setSelectedTabs(tab);
  };

  return (
    <div className='border-b border-gray-400 dark:border-gray-800'>
      <div className='sticky top-0 w-full flex flex-col items-start gap-2 justify-between px-8 py-6'>
        <div className='flex flex-row items-center justify-between w-full'>
          <p className='text-[28px] leading-[19.2px] font-semibold'>
            {mode === modalModes.ADD ? 'Enter' : 'Update'} Your Data
          </p>
          <picture>
            <source
              srcSet={WhiteCloseIcon}
              media='(prefers-color-scheme: dark)'
            />
            <img
              className='cursor-pointer'
              src={CloseIcon}
              alt=''
              onClick={onClose}
            />
          </picture>
        </div>
        <p className='text-[16px] leading[24px] font-light text-gray-850'>
          Enter your information or select data from nearly 100 companies to
          overlay it with Compass software benchmarks¹ and access more features.
          Need help calculating any of the below metrics? Check out our{' '}
          <a
            href='https://www.iconiq.com/growth/insights/the-saas-glossary'
            target='_blank'
            className='text-[16px] leading[24px] cursor-pointer'
            rel='noreferrer'
          >
            software glossary
          </a>{' '}
          for recommended calculations.
        </p>
      </div>
      <div className='w-full flex items-center justify-center'>
        {isAuthenticated &&
          Object.values(modalTabs).map(tab => (
            <Button
              id={`${tab.toLowerCase().replaceAll(' ', '-')}-tab-button`}
              key={tab}
              label={tab}
              className={`text-lg pb-4 px-8 ${selectedTabs === tab
                  ? 'text-green-700 font-semibold border-b-2 border-solid border-green-700'
                  : 'text-gray-700'
                } ${tab === modalTabs.SAVED_USER_DATA &&
                'walkthrough-saved-user-data'
                }`}
              onClick={() => { handleTabClick(tab); }}
            />
          ))}
      </div>
    </div>
  );
};

export default Header;
